// extracted by mini-css-extract-plugin
export default {"title":"title_title__2abqI typography_text--md__WpH5b","projectLink":"title_projectLink__B6XSw"};